import {v4 as uuidv4} from 'uuid';
import {ItemSeriesResultDto} from '../../common/shared/api/gateway/ItemSeriesResultDto.interface';
import {
  InvenRecommendList,
  Maybe,
  MetaInfoType,
  User,
} from '../generated/types';
import {createPosterViewItem} from './PosterViewItem';

export function createInvenRecommedList(
  userInfo: Maybe<User>,
  result: ItemSeriesResultDto
): InvenRecommendList {
  const id = uuidv4();
  return {
    id,
    list: result.list
      ? result.list.map(item =>
          createPosterViewItem(userInfo, {
            itemSeriesDto: item,
            metaInfoType: MetaInfoType.ViewCount,
          })
        )
      : [],
  };
}
